import React from "react";
import { Helmet } from "react-helmet";
import BannerSection from "./BannerSection";
import Navbar from "../../components/Navbar";
import WhyChoose from "./WhyChoose";
import Footer from "../../components/Footer";
import AboutTestimoinals from "./AboutTestimoinals";
import HowItWorks from "./HowItWorks";
const About = () => {
  return (
    <>
      <Helmet>
        <title>Dine Easy - About</title>
      </Helmet>

      <BannerSection />
      <WhyChoose />
      <HowItWorks />
      <AboutTestimoinals />
    </>
  );
};

export default About;
